import {Link} from "react-router-dom";
import clsx from 'clsx'

import { Container } from '../components/Container'
import {
    TwitterIcon,
} from '../components/SocialIcons'
import portraitImage from '/images/portrait.jpg'
import iqCertificateImage from '/images/iq-certificate.png'

import {Helmet} from "react-helmet-async";
import {Header} from "../components/Header.jsx";
import {Footer} from "../components/Footer.jsx";

function SocialLink({ className, href, children, icon: Icon }) {
    return (
        <li className={clsx(className, 'flex')}>
            <Link
                href={href}
                className="group flex text-sm font-medium text-zinc-800 transition hover:text-teal-500 dark:text-zinc-200 dark:hover:text-teal-500"
            >
                <Icon className="h-6 w-6 flex-none fill-zinc-500 transition group-hover:fill-teal-500" />
                <span className="ml-4">{children}</span>
            </Link>
        </li>
    )
}

function MailIcon(props) {
    return (
        <svg viewBox="0 0 24 24" aria-hidden="true" {...props}>
            <path
                fillRule="evenodd"
                d="M6 5a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V8a3 3 0 0 0-3-3H6Zm.245 2.187a.75.75 0 0 0-.99 1.126l6.25 5.5a.75.75 0 0 0 .99 0l6.25-5.5a.75.75 0 0 0-.99-1.126L12 12.251 6.245 7.187Z"
            />
        </svg>
    )
}

export default function Iq() {
    return (
        <div>
            <Helmet>
                <title>Michael Leitz</title>
                <meta name="description"
                      content="I'm Leitz, a software guy who's done every job in tech. Based in Nashville, TN. I help people understand the tech world by sharing wisdom acquired in my 25 years of professional delopment experience."/>
                <meta property="og:title" content="Leitz - Home"/>
                <meta
                    property="og:description"
                    content="Personal site of Michael Leitz, prolific software developer and manager"
                />
                <meta property="og:image" content="/images/portrait.jpg"/>
                <meta property="og:type" content="website"/>
            </Helmet>
            <Header />
            <main className="main flex flex-col items-center py-10">
                <Container className="mt-16 sm:mt-32">
                    <div className="grid grid-cols-1 gap-y-16 lg:grid-cols-2 lg:grid-rows-[auto_1fr] lg:gap-y-12">
                        <div className="lg:pl-20">
                            <div className="max-w-xs px-2.5 lg:max-w-none">
                                <img
                                    src={portraitImage}
                                    alt=""
                                    sizes="(min-width: 1024px) 32rem, 20rem"
                                    className="aspect-square rotate-3 rounded-2xl bg-zinc-100 object-cover dark:bg-zinc-800"
                                />
                            </div>
                        </div>
                        <div className="lg:order-first lg:row-span-2">
                            <h1 className="text-4xl font-bold tracking-tight text-zinc-800 dark:text-zinc-100 sm:text-5xl">
                                I’m Mike Leitz and my IQ score is 128
                            </h1>
                            <br></br>

                            <div className="mt-6 space-y-7 text-base text-zinc-600 dark:text-zinc-400">
                                <p>
                                    Everyone in the software business likes to think they're the smartest around. When I was first getting started as a developer, I was insecure and thought all aspects of building software was a competition. A way to show I was smarter than everyone else. A score of 128 would have been a blow to my fragile ego back then. I wouldn't have shared this number with anyone. I would have been too embarrassed and ashamed of it.
                                </p>
                                <p>
                                    I've gone through many phases during my software career -- a maturing.
                                </p>
                                <p>
                                    I'm now at the point where I'm willing to take an IQ test on realiq.online and show it to the world. I pledged this on X.com before I took the test. Good or bad I was taking the test and publishing the results.
                                </p>
                                <p>
                                    Here it is. A 128. Puts me at 1 and 20. Top 5%. I suspect as a software developer this puts me right in the middle of all developers.
                                </p>
                                <p>
                                    I'm hoping that by publishing my score, I might help someone who's in the same position I was in 25 years ago. Insecure about my analytical ability.
                                </p>
                                <p>Everyone who writes software is smart. </p>
                                <p>By being a developer, you've already made it and proved to the world you're smart enough. </p>
                                <p>Building the best software requires you to work in a team and do your part the best you can. Software development isn't an individual sport. It's a team game. The best teams have talented people working together on a common goal.</p>
                            </div>
                            <div className="p-12 max-w-xs px-2.5 lg:max-w-none">
                                <img
                                    src={iqCertificateImage}
                                    alt=""
                                    sizes="(min-width: 1024px) 32rem, 20rem"
                                    className=" bg-zinc-100 object-cover dark:bg-zinc-800"
                                />
                            </div>
                        </div>
                        <div className="lg:pl-20">
                            <ul role="list">
                                <SocialLink href="https://x.com/mleitz1" icon={TwitterIcon}>
                                    mleitz1 on Twitter
                                </SocialLink>
                                <SocialLink
                                    href="mailto:leitz@mikeleitz.com"
                                    icon={MailIcon}
                                    className="border-t border-zinc-100 pt-3dark:border-zinc-700/40"
                                >
                                    leitz@mikeleitz.com
                                </SocialLink>
                            </ul>
                        </div>
                    </div>
                </Container>
            </main>
            <Footer />
        </div>
    )
}
